export const taskKeys = {
  all: ['tasks'] as const,
  lists: () => [...taskKeys.all, 'list'] as const,
  list: (filters: Record<string, any>) => [...taskKeys.lists(), { ...filters }] as const,
  details: () => [...taskKeys.all, 'detail'] as const,
  detail: (id: string) => [...taskKeys.details(), id] as const,
}

export const messageKeys = {
  all: ['messages'] as const,
  list: () => [...messageKeys.all, 'list'] as const,
}

/*
['tasks', 'list', { filters: 'all' }]
['tasks', 'list', { filters: 'done' }]
['tasks', 'detail', 1]
['tasks', 'detail', 2]


// Example usage:
// 🕺 remove everything related
// to the todos feature
queryClient.removeQueries({
  queryKey: taskKeys.all
})

// 🚀 invalidate all the lists
queryClient.invalidateQueries({
  queryKey: taskKeys.lists()
})

// 🙌 prefetch a single task
queryClient.prefetchQueries({
  queryKey: taskKeys.detail(id),
  queryFn: () => fetchTask(id),
})


// updates from mutation responses
function useUpdateTitle() {
  return useMutation({
    mutationFn: updateTitle,
    onSuccess: (newTodo) => {
      // ✅ update the todo detail
      queryClient.setQueryData(
        ['todos', 'detail', newTodo.id],
        newTodo
      )

      // ✅ update all the lists that contain this todo
      queryClient.setQueriesData(['todos', 'list'], (previous) =>
        previous.map((todo) =>
          todo.id === newTodo.id ? newtodo : todo
        )
      )

      // ✅ update the list we are currently on
      queryClient.setQueryData(
        ['todos', 'list', { filters }],
        (previous) =>
          previous.map((todo) =>
            todo.id === newTodo.id ? newtodo : todo
          )
      )

      // 🥳 invalidate all the lists,
      // but don't refetch the active one
      queryClient.invalidateQueries({
        queryKey: ['todos', 'list'],
        refetchActive: false,
      })

    },
  })
}
*/